<template>
  <v-container style="margin-top: -10px" class="pt-0" :fill-height="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm">
    <!-- <v-overlay
      :absolute="false"
      :value="overlay"
      color="#5C9DF2">
      <v-speed-dial style="right: -105%;">
        <template v-slot:activator>
          <v-btn color="blue" fab id="close-button" @click="overlay = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-speed-dial>
      <BucketDropzone
        :acceptedFiles="acceptedFiles"
        :clientRFC="$store.getters.user.client.rfc"
        @onSatOpen="openSatCredentials"
        @onDisconectSat="openOnDisconectSat"
        @successS3Upload="registerInvoices"
        :overlay.sync="overlay"
        :stopAnimations.sync="stopAnimations"
      />
    </v-overlay> -->
    <v-row class="text-center mt-0 pa-0">
      <v-col cols="6" class="pa-0" v-if="infoBI.multimoneda && infoBI.creditCurrency === 'MXN'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          BLÚ INDEX
        </h3>
        <h2 class="primary--text font-weight-black"
            :class="{
              'disabled--text': !$store.getters.isActiveBI,
              'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
            }"
        >
          {{ infoBI.availableMXN | currency({fractionCount: 0 }) }} MXN
        </h2>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveBI}">O su equivalente</h5>
        <h4 class="primary--text font-weight-black" :class="{'disabled--text': !$store.getters.isActiveBI}">{{ infoBI.availableUSD | currency({fractionCount: 0 }) }} USD</h4>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveBI}"> TC: {{ infoBI.tipoCambio | currency({fractionCount: 4 }) }}</h5>
        <h5 class="error--text" v-show="!$store.getters.isActiveBI">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="infoBI.multimoneda && infoBI.creditCurrency === 'USD'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          BLÚ INDEX
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveBI,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }"
          >
            {{ infoBI.availableUSD | currency({fractionCount: 0 }) }} USD
          </h2>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveBI}">O su equivalente</h5>
        <h4 class="primary--text font-weight-black" :class="{'disabled--text': !$store.getters.isActiveBI}">{{ infoBI.availableMXN | currency({fractionCount: 0 }) }} MXN</h4>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveBI}"> TC: {{ infoBI.tipoCambio | currency({fractionCount: 4 }) }}</h5>
        <h5 class="error--text" v-show="!$store.getters.isActiveBI">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="!infoBI.multimoneda && infoBI.creditCurrency === 'MXN'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          BLÚ INDEX
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveBI,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }">
          {{ infoBI.availableMXN | currency({fractionCount: 0 }) }} MXN
        </h2>
        <h5 class="error--text" v-show="!$store.getters.isActiveBI">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="!infoBI.multimoneda && infoBI.creditCurrency === 'USD'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          BLÚ INDEX
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveBI,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }"
        >{{ infoBI.availableUSD | currency({fractionCount: 0 }) }} USD</h2>
        <h5 class="error--text" v-show="!$store.getters.isActiveBI">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="infoFB.multimoneda && infoFB.creditCurrency === 'MXN'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          FACTORAJE AMERICAN
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveFB,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }"
        >
          {{ infoFB.availableMXN | currency({fractionCount: 0 }) }} MXN
        </h2>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveFB}">O su equivalente</h5>
        <h4 class="primary--text font-weight-black" :class="{'disabled--text': !$store.getters.isActiveFB}">{{ infoFB.availableUSD | currency({fractionCount: 0 }) }} USD</h4>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveFB}"> TC: {{ infoFB.tipoCambio | currency({fractionCount: 4 }) }}</h5>
        <h5 class="error--text" v-show="!$store.getters.isActiveFB">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="infoFB.multimoneda && infoFB.creditCurrency === 'USD'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          FACTORAJE AMERICAN
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveFB,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }"
        >
          {{ infoFB.availableUSD | currency({fractionCount: 0 }) }} USD
        </h2>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveFB}">O su equivalente</h5>
        <h4 class="primary--text font-weight-black" :class="{'disabled--text': !$store.getters.isActiveFB}">{{ infoFB.availableMXN | currency({fractionCount: 0 }) }} MXN</h4>
        <h5 style="color: #5C9DF2" :class="{'disabled--text': !$store.getters.isActiveFB}"> TC: {{ infoFB.tipoCambio | currency({fractionCount: 4 }) }}</h5>
        <h5 class="error--text" v-show="!$store.getters.isActiveFB">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="!infoFB.multimoneda && infoFB.creditCurrency === 'MXN'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          FACTORAJE AMERICAN
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveFB,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }"
        >{{ infoFB.availableMXN | currency({fractionCount: 0 }) }} MXN</h2>
        <h5 class="error--text" v-show="!$store.getters.isActiveFB">Carga de facturas bloqueada</h5>
      </v-col>
      <v-col cols="6" class="pa-0" v-if="!infoFB.multimoneda && infoFB.creditCurrency === 'USD'">
        <h3 style="color: #5C9DF2"
            :class="{'subtitle-2 font-weight-bold': $vuetify.breakpoint.mdAndDown}">
          FACTORAJE AMERICAN
        </h3>
        <h2
          class="primary--text font-weight-black"
          :class="{
            'disabled--text': !$store.getters.isActiveFB,
            'text-h6 font-weight-bold': $vuetify.breakpoint.mdAndDown
          }"
        >
          {{ infoFB.availableUSD | currency({fractionCount: 0 }) }} USD
        </h2>
        <h5 class="error--text" v-show="!$store.getters.isActiveFB">Carga de facturas bloqueada</h5>
      </v-col>
    </v-row>
    <!-- Row de botones Mis Facturas y Facturas Preaprobadas -->
    <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" style="height: 9%; margin-top: -30px;">
      <v-col cols="5" lg="6" class="px-1">
        <v-tooltip bottom color="black" nudge-top="82">
          <template #activator="{ on, attrs }">
            <v-btn
              block
              color="light-grey"
              width="100%"
              class="small-text black--text"
              @click="applyFilters(false, false)"
              :class="{ shadow: !filterBySync }"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left small>mdi-file-document</v-icon>
              <span><strong>Mis</strong> Facturas</span>
            </v-btn>
          </template>
          <span>Facturas que subiste para adelantar su pago</span>
        </v-tooltip>
        <hr v-if="!filterBySync" class="divider" />
      </v-col>

      <v-col cols="7" lg="6" class="px-1">
        <v-tooltip bottom color="black" nudge-top="82">
          <template #activator="{ on, attrs }">
            <v-btn
              block
              color="#EC6C1C"
              width="100%"
              class="small-text white--text"
              @click="applyFilters(false, true)"
              :class="{ shadow: filterBySync }"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left small>mdi-flash</v-icon>
              <span>Facturas <strong>Preaprobadas</strong></span>
            </v-btn>
          </template>
          <span>Facturas precargadas disponibles para adelantar su pago</span>
        </v-tooltip>
        <hr v-if="filterBySync" class="divider" />
      </v-col>
    </v-row>
    <!-- Row de filtros con con checkbox -->
    <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" no-gutters align-end bottom absolute style="height: 5%; margin-top: -30px; display: flex; align-items: center; margin-right: 16px; width: 100%;">
      <!-- Columna izquierda: Checkbox para empresas preaprobadas -->
      <v-col
        cols="7"
        lg="7"
        md="7"
        class="text-left py-0 PX-0"
        style="display: flex; justify-content: left; justify-items: center;"
      >
        <div v-if="filterBySync">
          <!-- <SyncButton :active="taxpayer.hasValidCIEC &&
                      ($store.getters.isAuthBI || $store.getters.isAuthFB) &&
                      $store.getters.user.syncAllowed &&
                      $store.getters.user.SATsyncActive &&
                      !$store.getters.user.SATdownloading"/> -->
        </div>
        <div v-if="!filterBySync && hasOwnInvoices">
          <input
            type="checkbox"
            class="special-checkbox"
            :class="{
              'checkbox-orange': filterBySync,
              'checkbox-gray': !filterBySync,
            }"
            v-model="factoringCompanyFilter"
            @change="applyFilters()"
          />
          <label class="ml-2 checkbox-label">Empresas Preaprobadas</label>
        </div>
      </v-col>
      <!-- Columna derecha: Checkboxes para MXN y USD -->
      <v-col
        v-if="(hasOwnInvoices && !filterBySync) || (hasSyncInvoices && filterBySync)"
        cols="5"
        lg="5"
        md="5"
        class="text-left py-0 px-0"
        style="display: flex; justify-content: center; justify-items: center; width: 100%;"
      >
        <!-- Checkbox para MXN -->
        <input
          type="checkbox"
          class="special-checkbox"
          :class="{
            'checkbox-orange': filterBySync,
            'checkbox-gray': !filterBySync,
          }"
          v-model="filterByMXN"
          @change="applyFilters()"
        />
        <label class="ml-2 checkbox-label">MXN</label>

        <!-- Checkbox para USD -->
        <input
          type="checkbox"
          class="special-checkbox ml-4"
          :class="{
            'checkbox-orange': filterBySync,
            'checkbox-gray': !filterBySync,
          }"
          v-model="filterByUSD"
          @change="applyFilters()"
        />
        <label class="ml-2 checkbox-label">USD</label>
      </v-col>
    </v-row>
    <!-- <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" class="caption" style="height: 2%; margin-top: -70px; margin-left: 2px; width: 100%;">
      <div v-if="filterBySync && $store.getters.user.SATdownloading">
        * Actualización de facturas en curso...
      </div>
      <div v-if="filterBySync && !$store.getters.user.SATdownloading && $store.getters.user.SATsyncAt && ($store.getters.isAuthBI || $store.getters.isAuthFB)">
        * Última actualización el {{satInfoDate}} a las {{ satInfoTime }}
      </div>
    </v-row> -->
    <!-- Row de grupos de facturas -->
    <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" style="height: 30%; margin-top: -50px;">
      <!-- Columna si cuenta con grupos de facturas -->
      <v-col v-if="groupsFiltered.length" cols="12" class="pt-0">
        <v-row id="grid">
          <v-flex :class="configs[item.config].layout" class="pa-1" v-for="(item, index) in groupsFiltered" :key="index">
            <v-tooltip bottom color="black" nudge-top="100">
              <template v-slot:activator="{ on }">
                  <v-card
                    v-on="on"
                    @click="selectTile(item)"
                    class="px-2 text-center white--text tile"
                    :class="{
                      'tile-deseleccionado': (item.selected === false || !item.selected),
                      'tile-seleccionado': item.selected === true,
                      'tile-orange-1': filterBySync && item.config === 1,
                      'tile-orange-2': filterBySync && item.config === 2,
                      'tile-orange-3': filterBySync && item.config === 3,
                      'tile-orange-4': filterBySync && item.config === 4,
                      'tile-gray-1': !filterBySync && item.config === 1,
                      'tile-gray-2': !filterBySync && item.config === 2,
                      'tile-gray-3': !filterBySync && item.config === 3,
                      'tile-gray-4': !filterBySync && item.config === 4
                    }"
                    :disabled="(!$store.getters.isActiveBI && item.hasBI && !item.hasFB) || (!$store.getters.isActiveFB && item.hasFB && !item.hasBI)"
                    :style="{
                      'background-color':
                        (!$store.getters.isActiveBI && item.hasBI && !item.hasFB) ||
                        (!$store.getters.isActiveFB && item.hasFB && !item.hasBI) ?
                          '#D0D0D0' :
                          ''
                    }"
                    outlined
                    tile
                    :aspect-ratio="1/1"
                  >
                    <h5 class="font-weight-black text-uppercase d-inline-block text-truncate pt-2" style="max-width: 100%;">{{item.receiverName}}</h5>
                    <!-- <h5 class="font-weight-black text-uppercase">{{item.receiverName}}</h5> -->
                    <h5 v-if="item.totalMXN > 0">{{ item.totalMXN | currency({fractionCount: 0 }) }} MXN</h5>
                    <h5 v-if="item.totalUSD <= 0"><br></h5>
                    <h5 v-if="item.totalUSD > 0">{{ item.totalUSD | currency({fractionCount: 0 })}} USD</h5>
                    <h5 v-if="item.totalMXN <= 0"><br></h5>
                  </v-card>
              </template>
              <h4 class="font-weight-black text-uppercase white--text">{{item.receiverName}}</h4>
            </v-tooltip>
          </v-flex>
        </v-row>
      </v-col>
      <!-- Columna si no tiene grupos de facturas o tiene según si está en Mis Facturas o Facturas Preaprobadas -->
      <div style="text-align: center;">
        <div v-if="!filterBySync">
          <v-col v-if="!hasOwnInvoices || !groupsFiltered.length">
            <strong>No tienes facturas</strong> 😞<br>
            ¡Déjanos ayudarte! Haz clic en el botón “Facturas Preaprobadas” para ver las facturas que puedes adelantar hoy mismo.
          </v-col>
        </div>
        <div v-else>
          <v-col v-if="!hasSyncInvoices && (!taxpayer.hasValidCIEC || !($store.getters.isAuthBI || $store.getters.isAuthFB))">
            <strong>No tienes acceso a este servicio</strong> 😰<br>
            Para conocer los requisitos de uso de este servicio,
            <a :href="`https://wa.me/${$store.getters.user.client.promoterPhone}?text=Hola,%20quiero%20información%20sobre%20los%20requisitos%20para%20usar%20el%20servicio%20de%20facturas%20preaprobadas%20en%20el%20portal,%20por%20favor`"
            target="_blank"
            style="color: #007aff; text-decoration: none;"
            > contáctanos</a>.
          </v-col>
          <v-col v-else-if="!hasSyncInvoices && taxpayer.hasValidCIEC && ($store.getters.isAuthBI || $store.getters.isAuthFB)">
            <br><strong>No tienes facturas preaprobadas</strong> 🤔 <br>
            ¡No te preocupes! Puedes subirlas manualmente desde la sección Mis Facturas 😊</v-col>
        </div>
      </div>
    </v-row>
    <!-- Row para el checkbox de "Seleccionar Todo" -->
    <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" no-gutters align-end bottom absolute style="height: 3%; margin-top: -50px;">
      <v-col v-if="groupsFiltered.length"
        cols="12"
        lg="12"
        md="12"
        class="text-left py-0 px-0"
      >
        <input
          type="checkbox"
          class="special-checkbox"
          v-model="selectAll"
          @change="toggleSelectAll()"
        />
        <label class="ml-2 checkbox-label">Seleccionar todo (incluye filtros)</label>
      </v-col>
    </v-row>
    <!-- Row para botones de Subir Facturas y Vender -->
    <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" class="text-center" no-gutters align-end bottom absolute style="height: 5%; margin-top: -40px;">
      <v-col cols="6" class="px-1">
        <v-btn
          v-if="!$store.getters.isActiveBI && !$store.getters.isActiveFB"
          id="btnUpload"
          @click="openOverlay"
          width="100%"
          color="light-grey"
          class="subtitle-2 black--text"
          :class="{
            'subtitle-2': $vuetify.breakpoint.mdAndDown
          }"
          block
          rounded
        >
          <v-icon class="black--text">mdi-upload</v-icon>
          <span v-if="!$vuetify.breakpoint.md"><strong>Subir</strong> facturas</span>
        </v-btn>
        <BucketDropzone
          v-else
          :acceptedFiles="acceptedFiles"
          :clientRFC="$store.getters.user.client.rfc"
          @onSatOpen="openSatCredentials"
          @onDisconectSat="openOnDisconectSat"
          @successS3Upload="registerInvoices"
          :overlay.sync="overlay"
          :stopAnimations.sync="stopAnimations"
        />
      </v-col>
      <v-col cols="6" class="px-1">
        <v-btn
          id="btnSale"
          width="100%"
          rounded
          block
          color="#5C9DF2"
          :class="{
            'disabled': !$store.getters.isAuthBI && !$store.getters.isAuthFB,
            'subtitle-2': $vuetify.breakpoint.mdAndDown
          }"
          class="font-weight-black white--text subtitle-2"
          @click="saleInvoices()"
          >
          <v-icon>
            mdi-currency-usd
          </v-icon>
          Vender
        </v-btn>
        <v-dialog scrollable width="85%" v-model="modal" persistent>
          <InvoiceLoader
              height="100%"
              ref="invoiceLoader"
              :key="invoiceLoaderKey"
              :invoicesGroups.sync="invoicesToSell"
              :infoBI="infoBI"
              :infoFB="infoFB"
              :failedFiles="failedFiles"
              :productTypes="productTypes"
              @onClose="onCloseModal"
              @onSell="getInvoices()"/>
              <!-- :modal.sync="modal" -->
        </v-dialog>
      </v-col>
    </v-row>

    <v-dialog width="35%" v-model="successSellingModal" persistent overlay-color="#5B9DF2" transition="scale-transition" origin="center center">
      <SuccessSelling @onClose="successSellingModal = false" v-if="successSellingModal" :hasBI="hasBI" :hasFB="hasFB"/>
    </v-dialog>

    <v-dialog
      width="50%"
      v-model="onSyncSatModal"
      overlay-color="#5B9DF2"
      transition="scale-transition"
      persistent
      origin="center center"
    >
      <ConnectSat @onClose="onSyncSatModal = false" :key="connectSatKey"/>
    </v-dialog>
    <v-dialog
      width="35%"
      v-model="onConstructionModal"
      overlay-color="#5B9DF2"
      transition="scale-transition"
      persistent
      origin="center center"
    >
      <OnConstruction @onClose="onConstructionModal = false"/>
    </v-dialog>
    <v-dialog
      width="35%"
      v-model="onDisconectSatModal"
      overlay-color="#5B9DF2"
      transition="scale-transition"
      origin="center center"
    >
      <DisconectSat @onClose="onDisconectSatModal = false"/>
    </v-dialog>

  </v-container>
</template>

<script>
import Vue from 'vue'
import FileTypes from '@/common/FileTypes'
import InvoiceLoader from '@/components/InvoiceLoader'
import SuccessSelling from '@/components/SuccessSelling'
import Status from '@/common/FactoringDocumentStatus'
import DragonStatus from '@/common/DragonStatus'
import { GEN_RFC } from '@/common/constantes'
import ClientFileService from '@/services/ClientFileService'
import FactoringCompanyService from '@/services/FactoringCompanyService'
import BucketDropzone from '@/components/Uploads/BucketDropzone'
import OnConstruction from '@/components/SAT/OnConstruction'
// import SyncButton from '@/components/SAT/SyncButton'
import ConnectSat from '@/components/SAT/ConnectSat'
import DisconectSat from '@/components/SAT/DisconectSat'
import RiskInsightsService from '@/services/RiskInsightsService'
// import moment from 'moment'
import * as Sentry from '@sentry/vue'
import moment from 'moment-timezone'
import CiecStatus from '@/common/CiecStatus'

export default {
  name: 'TilesGrid',
  props: {
    productTypes: {
      type: Object,
      required: true
    }
  },
  components: {
    // SyncButton,
    BucketDropzone,
    InvoiceLoader,
    SuccessSelling,
    ConnectSat,
    DisconectSat,
    OnConstruction
  },
  data () {
    return {
      configs: [
        { layout: null },
        { layout: 'xs6' },
        { layout: 'xs5' },
        { layout: 'xs4' },
        { layout: 'xs3' }
      ],
      invoicesToSell: [],
      factoringCompanies: [],
      factoringCompanyFilter: true,
      currencyFilter: ['MXN', 'USD'],
      successSellingModal: false,
      onSyncSatModal: false,
      connectSatKey: 0,
      onDisconectSatModal: false,
      onConstructionModal: false,
      modal: false,
      overlay: false,
      selectAll: false,
      invoiceLoaderKey: 0,
      acceptedFiles: '.xml',
      failedFiles: [],
      stopAnimations: false,
      filterBySync: true,
      filterByMXN: true,
      filterByUSD: true,
      groupsFiltered: [],
      hasSyncInvoices: true,
      hasOwnInvoices: true,
      taxpayer: {},
      invoicesToSellSelected: [],
      hasBI: false,
      hasFB: false
    }
  },

  watch: {
    '$store.getters.user.SATdownloading' (newValue, oldValue) {
      if (!newValue && oldValue) {
        this.refreshAfterAction()
      }
    }
  },
  methods: {
    animateSaleButton () {
      var self = this
      setInterval(async function () {
        if (!self.stopAnimations && (self.$store.getters.isActiveBI || self.$store.getters.isActiveFB)) {
          let buttonToAnimateId = ''
          const invoicesToSell = self.$store.getters.invoicesGroups.filter(group =>
            group.invoices.some(invoice =>
              invoice.status === Status.AUTORIZADA || invoice.status === Status.REGISTRADO
            )
          )
          if (invoicesToSell.length > 0) {
            buttonToAnimateId = 'btnSale'
          } else {
            buttonToAnimateId = 'btnUpload'
          }

          const buttonToAnimate = document.getElementById(buttonToAnimateId)
          if (buttonToAnimate) {
            if (buttonToAnimate.classList) {
              await buttonToAnimate.classList.toggle('animated-button')
            } else {
              // For IE9
              var classes = buttonToAnimate.className.split(' ')
              var i = classes.indexOf('animated-button')

              if (i >= 0) {
                classes.splice(i, 1)
              } else {
                classes.push('animated-button')
                buttonToAnimate.className = classes.join(' ')
              }
            }
          }
        }
      }, 5000)
    },
    saleInvoices () {
      if (!this.$store.getters.isActiveBI && !this.$store.getters.isActiveFB) {
        this.$swal({
          title: '¡Error!',
          html: 'Tienes deshabilitada esta función temporalmente. <br><br> Si tienes dudas, consulta a tu asesor.',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#1374F2',
          showCloseButton: true
        })
        return
      }
      if (this.isSomeTileSelected === true) {
        this.openModal()
      } else {
        this.$swal({
          title: '¡Error!',
          html: 'Selecciona a uno de tus clientes para proceder a la venta',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#1374F2',
          showCloseButton: true
        })
      }
    },
    openOverlay () {
      if (!this.$store.getters.isActiveBI && !this.$store.getters.isActiveFB) {
        this.$swal({
          title: '¡Error!',
          html: 'Tienes deshabilitada esta función temporalmente. <br><br> Si tienes dudas, consulta a tu asesor.',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#1374F2',
          showCloseButton: true
        })
      } else {
        this.overlay = !this.overlay
        this.stopAnimations = true
      }
    },
    openSatCredentials () {
      this.modal = false
      this.overlay = false
      if (this.$store.getters.user.syncAllowed) {
        this.onSyncSatModal = true
      } else {
        this.onConstructionModal = true
      }
      this.connectSatKey += 1
    },
    openOnDisconectSat () {
      this.modal = false
      this.overlay = false
      this.onDisconectSatModal = true
    },
    async onCloseModal (sell = false, invoices = []) {
      this.modal = false
      this.failedFiles = []
      this.stopAnimations = false
      this.hasFB = false
      this.hasBI = false

      if (sell) {
        const selledProducts = new Set(invoices.map(item => item.Product.code))
        // Determinar cuales productos se vendieron
        this.hasFB = selledProducts.has('FB')
        this.hasBI = selledProducts.has('BI')

        const loader = this.$loading.show()
        await this.refreshAfterAction()
        loader.hide()
        this.stopAnimations = true
        this.successSellingModal = true
      }
    },
    selectTile (tile) {
      // Se se des-selecciona una y "seleccionar todo" estaba activo, selectAll se vuelve false
      if (tile.selected && this.selectAll) this.selectAll = false
      Vue.set(tile, 'selected', !tile.selected)
    },
    toggleSelectAll () {
      for (const item of this.groupsFiltered) {
        Vue.set(item, 'selected', this.selectAll)
      }
    },
    async openModal (firstLoad = false) {
      this.stopAnimations = true
      const now = new Date()
      const date = moment(now.toISOString()).locale('es').format('YYYY-MM-DD')
      this.invoiceLoaderKey += 1
      const loader = this.$loading.show()
      const week = { monday: false, tuesday: false, wednesday: false, thursday: false, friday: true }
      if (this.overlay || firstLoad) {
        // Actualizar in the back para filtro de dragones sobre facturas recién subidas
        this.getFactoringCompanies()
        // En este caso se filtran todas las que ha subido el cliente
        await this.applyFilters(false, false, true)
        this.invoicesToSell = this.groupsFiltered.filter(group =>
          group.invoices.some(invoice =>
            invoice.status === Status.AUTORIZADA ||
            invoice.status === Status.REGISTRADO ||
            (invoice.status === Status.RECHAZADA && invoice.rejectedDate === date)
          )
        )
      } else {
        if (!firstLoad) {
          // En este otro caso, aparecen las que cumplen con los filtros seleccionados
          this.invoicesToSell = this.groupsFiltered.filter(group => group.selected === true).map(group => Object.assign(group, { dueDate: null }))
        }
      }

      let factoringCompanies = []
      try {
        factoringCompanies = await Promise.all(this.invoicesToSell.map(
          item => FactoringCompanyService.getByRFC({
            rfc: item.receiverRFC,
            razonSocial: item.receiverName,
            clientId: this.$store.getters.user.clientId
          })
        ))
        factoringCompanies = factoringCompanies.map(item => item.data).flat()
      } catch (error) {
        console.info('Error getting factoring companies', error)
        Sentry.captureException(error)
      }
      for (const group of this.invoicesToSell) {
        if (firstLoad) {
          group.invoices = group.invoices.filter(invoice =>
            invoice.status === Status.AUTORIZADA ||
            invoice.status === Status.REGISTRADO ||
            (invoice.status === Status.RECHAZADA && invoice.rejectedDate === date)
          )
        } else {
          group.invoices = group.invoices.filter(invoice =>
            invoice.status === Status.AUTORIZADA ||
            invoice.status === Status.REGISTRADO ||
            (invoice.status === Status.RECHAZADA && invoice.rejectedDate === date)
          )
        }

        let factoringCompany = null
        if (group.receiverRFC === 'XEXX010101000') {
          factoringCompany = factoringCompanies.find(company => company.razonSocial.toLowerCase() === group.receiverName.toLowerCase() && company.rfc === group.receiverRFC)
        } else {
          factoringCompany = factoringCompanies.find(company => company.rfc === group.receiverRFC)
        }
        if (factoringCompany) {
          group.paymentDays = factoringCompany && factoringCompany.paymentDays.length > 0 ? factoringCompany.paymentDays[0] : { paymentDays: 0, weekDays: Object.assign({}, week) }
        } else {
          group.paymentDays = { paymentDays: 0, weekDays: Object.assign({}, week) }
        }

        for (const invoice of group.invoices) {
          invoice.selected = false
        }
        group.invoices = group.invoices.sort((a, b) => a.emittedOn === b.emittedOn ? 0 : a.emittedOn < b.emittedOn ? 1 : -1)
      }
      this.invoicesToSell = this.invoicesToSell.filter(group => group.invoices.length > 0)

      this.overlay = false
      await this.$store.dispatch('updateInvoicesGroups')
      this.invoicesToSell = await this.invoicesToSell.filter(group => group.invoices.length > 0)
      this.modal = true
      loader.hide()
    },

    async getInvoices () {
      try {
        await this.$store.dispatch('setInvoices')
        await this.getCreditsInformation()
        this.stopAnimations = false
      } catch (error) {
        console.error(error)
      }
    },

    // async getGroupsPaymentDays () {
    //   for (const group of this.$store.getters.invoicesGroups) {
    //     let hasSalableInvoices = group.invoices.some(invoice =>
    //       invoice.status === Status.REGISTRADO ||
    //       invoice.status === Status.AUTORIZADA
    //     )
    //     if (hasSalableInvoices) {
    //       try {
    //         let { data } = await FactoringCompanyService.getByRFC({
    //           rfc: group.receiverRFC,
    //           razonSocial: group.receiverName,
    //           clientId: this.$store.getters.user.clientId
    //         })
    //         if (data.length > 0) {
    //           let dragonCompany = data.length > 1 ? data.find(company => company.razonSocial.toLowerCase() === group.receiverName.toLowerCase()) : data[0]
    //           group.paymentDays = dragonCompany && dragonCompany.paymentDays.length > 0 ? dragonCompany.paymentDays[0] : {}
    //         } else {
    //           group.paymentDays = {}
    //         }
    //       } catch (error) {
    //         console.error(error)
    //       }
    //     }
    //   }
    // },

    async getCreditsInformation () {
      const factoringCredits = ['BI', 'FB']
      try {
        await this.$store.dispatch('setCreditsInformation', { emitterRFC: this.$store.getters.user.client.rfc, products: factoringCredits })
        // AQUI SE HARDCODEA PARA PODER PROBAR LAS LINEAS DE CREDITO
        // Clientes con Blu index
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'DIB141028514', products: factoringCredits }) // MXN
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'COP130603UI5', products: factoringCredits }) // USD
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'COUE740630CV5', products: factoringCredits }) // MXN multimoneda
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'AIF1402108C1', products: factoringCredits }) // USD multimoneda

        // Clientes con Factoraje Blu
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'MIAC871123EK2', products: factoringCredits }) // MXN
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'CIR040707UB0', products: factoringCredits }) // USD
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'ECM190924RS5', products: factoringCredits }) // MXN multimoneda
        // await this.$store.dispatch('setCreditsInformation', { emitterRFC: 'NEFD890315S17', products: factoringCredits }) // USD multimoneda
        return this.$store.getters.creditsInformation
      } catch (error) {
        console.error(error)
        return null
      }
    },

    async registerInvoices (uploadedFiles) {
      const loader = this.$loading.show()
      this.failedFiles = []
      const creditsInformation = await this.getCreditsInformation()
      if (creditsInformation) {
        try {
          let docs = await Promise.all(uploadedFiles.map(
            item => ClientFileService.createFile({
              clientId: this.$store.getters.user.clientId,
              fileURL: item.uri,
              fileName: item.fileName,
              fileType: FileTypes.INVOICE,
              fileData: {},
              clientRFC: this.$store.getters.user.client.rfc,
              creditsInformation: this.$store.getters.creditsInformation,
              uploadedBy: this.$store.getters.user.userId
            }))
          )
          docs = docs.map(item => item.doc)
          for (const doc of docs) {
            if (doc.receiverRFC === 'FALLIDOS') {
              this.failedFiles.push(doc)
            } else {
              this.$store.dispatch('setInvoice', {
                data: doc,
                firstLoad: false
              })
            }
          }
        } catch (error) {
          console.error(error)
        }
        loader.hide()
        this.openModal(true)
        this.stopAnimations = false
      } else {
        loader.hide()
        this.stopAnimations = false
        this.$swal('Lo sentimos!', 'Estamos teniendo problemas para procesar tus archivos, por favor intenta mas tarde', 'error')
        this.overlay = false
      }
    },
    isFilterBy (value) {
      if (this.currencyFilter.includes(value)) { return true }
      return false
    },
    async getFactoringCompanies () {
      if (!this.factoringCompanyFilter) return
      let factoringCompanies = []
      const loader = this.$loading.show()
      try {
        const getByRFC = ({ receiverRFC: rfc, receiverName: razonSocial }) => FactoringCompanyService.getByRFC({ rfc, razonSocial })
        factoringCompanies = await Promise.all(this.$store.getters.invoicesGroups.map(getByRFC))
        this.factoringCompanies = factoringCompanies
          .filter(({ data = null } = {}) => data && data.length)
          .map(({ data: [{ rfc, razonSocial, statusId }] }) => ({ rfc, razonSocial, statusId }))
      } catch (error) {
        console.error('Error getting factoring companies', error)
        Sentry.captureException(error)
      }
      loader.hide()
    },
    async applyFilters (firstLoad = false, filterBySyncValue = null, initialSellModal = false) {
      // Des-seleccionar todas
      this.selectAll = false
      this.toggleSelectAll()

      if (typeof filterBySyncValue === 'boolean') {
        this.filterBySync = filterBySyncValue
        // Sirve de double-check para que las preaprobadas sean a dragones
        if (filterBySyncValue) this.factoringCompanyFilter = true
      }

      this.groupsFiltered = []
      let newFilteredInvoices = this.$store.getters.invoicesGroups

      // Busca entre Mis Facturas y Facturas Preaprobadas
      this.hasSyncInvoices = newFilteredInvoices.filter(group => group.isSyncGroup).length
      this.hasOwnInvoices = newFilteredInvoices.filter(group => !group.isSyncGroup).length

      if (firstLoad && !this.hasSyncInvoices) {
        this.filterBySync = false
      }

      // Filtrar facturas preaprobadas o no
      if (this.filterBySync) newFilteredInvoices = newFilteredInvoices.filter(group => group.isSyncGroup)
      else newFilteredInvoices = newFilteredInvoices.filter(group => !group.isSyncGroup)

      // Filtra por moneda
      const currencyFilter = []
      if (this.filterByMXN) currencyFilter.push('MXN')
      if (this.filterByUSD) currencyFilter.push('USD')
      newFilteredInvoices = newFilteredInvoices.filter(group => group.invoices.some(invoice => currencyFilter.includes(invoice.currency)))
      for (const group of newFilteredInvoices) {
        group.invoices = group.invoices.filter(invoice => currencyFilter.includes(invoice.currency))
      }
      // Filtra por empresas dragon
      const findCompany = this.factoringCompanyFilter
        ? ({ receiverName, receiverRFC }) => {
          if (receiverRFC !== GEN_RFC) return this.factoringCompanies.some(_ => _.rfc === receiverRFC && _.statusId === DragonStatus.APPROVED)
          return this.factoringCompanies.some(_ => _.rfc === receiverRFC && _.razonSocial === receiverName && _.statusId === DragonStatus.APPROVED)
        }
        : ({ receiverName, receiverRFC }) => {
          if (receiverRFC !== GEN_RFC) return this.factoringCompanies.some(_ => _.rfc === receiverRFC && _.statusId !== DragonStatus.APPROVED)
          return this.factoringCompanies.some(_ => _.rfc === receiverRFC && _.razonSocial === receiverName && _.statusId !== DragonStatus.APPROVED)
        }

      if (!initialSellModal) newFilteredInvoices = newFilteredInvoices.filter(findCompany)

      // Filtra estatus
      newFilteredInvoices = newFilteredInvoices
        .filter(group => group.invoices
          .some(invoice => invoice.status === Status.AUTORIZADA || invoice.status === Status.REGISTRADO)
        )

      this.groupsFiltered = newFilteredInvoices
    },
    async getTaxpayerData () {
      try {
        const response = await RiskInsightsService.getTaxpayer(this.$store.getters.user.client.rfc)
        this.taxpayer = response.rfc ? response : {}
        this.taxpayer.hasValidCIEC = (this.taxpayer.hasCiec === true && this.taxpayer.ciecStatus === CiecStatus.VALID)
      } catch (error) {
        console.error('Error fetching taxpayer data:', error)
      }
    },
    async refreshAfterAction () {
      const loader = this.$loading.show()
      await this.getInvoices()
      await this.getFactoringCompanies()
      await this.$store.commit('UPDATE_INVOICESGROUPS')
      await this.applyFilters()
      loader.hide()
    }
  },
  computed: {
    satInfoDate () {
      if (!this.$store.getters.user.SATsyncAt) { return null }
      return moment(this.$store.getters.user.SATsyncAt).locale('es').format('D [de] MMMM')
    },
    satInfoTime () {
      if (!this.$store.getters.user.SATsyncAt) { return null }
      return moment(this.$store.getters.user.SATsyncAt).locale('es').local().format('h:mm a')
    },
    satInfoToday () {
      const now = moment().locale('es').format('DD MMM')
      return now === this.satInfoDate
    },
    infoBI () {
      const infoBI = {}
      if (this.$store.getters.creditsGroups.BI && this.$store.getters.creditsGroups.BI.length) {
        const item = this.$store.getters.creditsGroups.BI.find(i => (i.limiteCredito > 0))
        if (item) {
          infoBI.creditCurrency = item.moneda
          infoBI.availableMXN = 0
          infoBI.availableUSD = 0
          infoBI.multimoneda = false
          infoBI.tipoCambio = 1
          infoBI.Product = {
            code: 'BI',
            name: 'Blú Index'
          }
        } else {
          infoBI.creditCurrency = 'MXN'
          infoBI.availableMXN = 0
          infoBI.availableUSD = 0
          infoBI.multimoneda = false
          infoBI.tipoCambio = 1
          infoBI.Product = {
            code: 'BI',
            name: 'Blú Index'
          }
        }

        const indexMXN = this.$store.getters.creditsGroups.BI.find(i => (i.moneda === 'MXN'))
        const indexUSD = this.$store.getters.creditsGroups.BI.find(i => (i.moneda === 'USD'))

        if (infoBI.creditCurrency === 'MXN') {
          if (indexMXN) {
            const principal = indexMXN
            infoBI.availableMXN = parseFloat(principal.limiteCredito - principal.saldoCreditos).toFixed(2)
            infoBI.creditLimit = parseFloat(principal.limiteCredito).toFixed(2)
            infoBI.creditUsed = parseFloat(principal.saldoCreditos).toFixed(2)
            infoBI.authorized = principal.autorizado

            if (indexUSD) {
              const secondary = indexUSD
              infoBI.multimoneda = true
              infoBI.availableUSD = parseFloat((principal.limiteCredito - principal.saldoCreditos) / secondary.tipoCambio).toFixed(2)
              infoBI.tipoCambio = secondary.tipoCambio
            }
          }
        }
        if (infoBI.creditCurrency === 'USD') {
          if (indexUSD) {
            const principal = indexUSD
            infoBI.availableUSD = (principal.limiteCredito - principal.saldoCreditos).toFixed()
            infoBI.tipoCambio = principal.tipoCambio
            infoBI.creditLimit = parseFloat(principal.limiteCredito).toFixed(2)
            infoBI.creditUsed = parseFloat(principal.saldoCreditos).toFixed(2)
            infoBI.authorized = principal.autorizado

            if (indexMXN) {
              infoBI.multimoneda = true
              infoBI.availableMXN = parseFloat((principal.limiteCredito - principal.saldoCreditos) * principal.tipoCambio).toFixed(2)
            }
          }
        }
      }

      // todo: falta restar el importe que tiene en PREVENTA
      return infoBI
    },
    infoFB () {
      const infoFB = {}
      if (this.$store.getters.creditsGroups.FB && this.$store.getters.creditsGroups.FB.length) {
        const item = this.$store.getters.creditsGroups.FB.find(i => (i.limiteCredito > 0))
        if (item) {
          infoFB.creditCurrency = item.moneda
          infoFB.availableMXN = 0
          infoFB.availableUSD = 0
          infoFB.multimoneda = false
          infoFB.tipoCambio = 1
          infoFB.Product = {
            code: 'FB',
            name: 'Factoraje American'
          }
        } else {
          infoFB.creditCurrency = 'MXN'
          infoFB.availableMXN = 0
          infoFB.availableUSD = 0
          infoFB.multimoneda = false
          infoFB.tipoCambio = 1
          infoFB.Product = {
            code: 'FB',
            name: 'Factoraje American'
          }
        }

        const itemMXN = this.$store.getters.creditsGroups.FB.find(i => (i.moneda === 'MXN'))
        const itemUSD = this.$store.getters.creditsGroups.FB.find(i => (i.moneda === 'USD'))

        if (infoFB.creditCurrency === 'MXN') {
          if (itemMXN) {
            const principal = itemMXN
            infoFB.availableMXN = parseFloat(principal.limiteCredito - principal.saldoCreditos).toFixed(2)
            infoFB.creditLimit = parseFloat(principal.limiteCredito).toFixed(2)
            infoFB.creditUsed = parseFloat(principal.saldoCreditos).toFixed(2)
            infoFB.authorized = principal.autorizado

            if (itemUSD) {
              const secondary = itemUSD
              infoFB.multimoneda = true
              infoFB.availableUSD = parseFloat((principal.limiteCredito - principal.saldoCreditos) / secondary.tipoCambio).toFixed(2)
              infoFB.tipoCambio = secondary.tipoCambio
            }
          }
        }
        if (infoFB.creditCurrency === 'USD') {
          if (itemUSD) {
            const principal = itemUSD
            infoFB.availableUSD = (principal.limiteCredito - principal.saldoCreditos).toFixed(2)
            infoFB.tipoCambio = principal.tipoCambio
            infoFB.creditLimit = parseFloat(principal.limiteCredito).toFixed(2)
            infoFB.creditUsed = parseFloat(principal.saldoCreditos).toFixed(2)
            infoFB.authorized = principal.autorizado

            if (itemMXN) {
              infoFB.multimoneda = true
              infoFB.availableMXN = parseFloat((principal.limiteCredito - principal.saldoCreditos) * principal.tipoCambio).toFixed(2)
            }
          }
        }
      }
      // todo: falta restar el importe que tiene en PREVENTA
      return infoFB
    },
    // invoicesTotal () {
    //   let invoicesAuth = this.$store.getters.invoices.filter(invoice => invoice.status === 20)
    //   return invoicesAuth.length > 0 ? invoicesAuth.map(invoice => invoice.total).reduce((accum, actual) => parseFloat(accum) + parseFloat(actual)) : 0
    // },
    isSomeTileSelected () {
      return this.groupsFiltered.some(group => group.selected === true)
    }
  },
  async mounted () {
    const loader = this.$loading.show()
    try {
      await this.getInvoices()
      await this.getFactoringCompanies()
      await this.getTaxpayerData()
      await this.applyFilters(true)
      await this.$emit('onFinishLoading')
      this.animateSaleButton()
      loader.hide()
    } catch (error) {
      loader.hide()
      console.info(error)
    }
  },

  filters: {
    twoZerosFilter (number) {
      return number.toFixed(2)
    },
    date (date) {
      return moment(date).local().format('DD-MMM-YYYY h:mm a')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/main.scss';
  #grid {height: 22vh; overflow-y: auto;}
  .tile {border-radius : 5px; border : none !important; padding-top : 25%; padding-bottom : 25%;}
  .tile-type-1 {background-color : $blu-4;}
  .tile-type-2 {background-color : $blu-3;}
  .tile-type-3 {background-color : $blu-2;}
  .tile-type-4 {background-color : $blu-1;}
  .tile-orange-1 {background-color : $orange-4;}
  .tile-orange-2 {background-color : $orange-3;}
  .tile-orange-3 {background-color : $orange-2;}
  .tile-orange-4 {background-color : $orange-1;}
  .tile-gray-1 {background-color : $gray-4;}
  .tile-gray-2 {background-color : $gray-3;}
  .tile-gray-3 {background-color : $gray-2;}
  .tile-gray-4 {background-color : $gray-1;}
  .checkbox-orange {accent-color : $orange-4;}
  .checkbox-gray {accent-color : $gray-4;}
  .tile-seleccionado{
    filter: contrast(0.5);
  }
  .tile-seleccionado:after{
    font-family: 'Material Design Icons';
    content: '\F132';
    /*content: '☑';*/
    display: block;
    height: 30px;  /*height of icon */
    width: 30px;  /*width of icon */
    position: absolute;
    top: 3%;
    left: 2%;
    color: white;
    font-size: 1.4rem;
  }
  .tile-deseleccionado :after{
    font-family: 'Material Design Icons';
    content: '\F1A2';
    /*content: '☐';*/
    display: block;
    height: 30px;
    width: 30px;
    position: absolute;
    top: 3%;
    left: 2%;
    color: white;
    font-size: 1.4rem;
  }
  #close-button {
    background-color: #0420BF !important;
  }

  .animated-button {
    -webkit-animation-name: shakeY;
    -webkit-animation-duration: 1.5s;
    -webkit-animation-iteration-count: 1;
    /*-webkit-animation-timing-function: linear;*/
    -webkit-animation-delay: 0s;
    /*-webkit-animation-direction: alternate;*/
  }

  .divider {
    width: 100%;
    border-top: 2px solid rgba(128, 128, 128, 0.5);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  .checkbox-label {
    text-size-adjust: initial;
    font-size: 80%;
  }

  .small-text {
    font-size: 55%;
  }

 /* @-webkit-keyframes test {
      0% {
      }
      5%,25% {
          text-shadow: -2px -5px 10px #fb0017,
                       -5px 0px 10px #3a00cd,
                       -5px 5px 10px #00ff3a;
      }
      15%,35% {
          text-shadow: 2px 5px 10px #fb0017,
                       5px 0px 10px #3a00cd,
                       5px -5px 10px #00ff3a;
      }
      40% {
        text-shadow: none;
    }
  }*/
</style>
